import React from "react";

/**
 * TopoTexture — faint topographic contour watermark.
 * Hand-drawn irregular contour rings + sweeping lines on a 1600x1000 canvas,
 * stretched with slice (cover) so it never visibly tiles. Static, pointer-events
 * none, aria-hidden. Radial mask fades the center where copy sits.
 * variant "light" = soft charcoal lines for light sections.
 * variant "dark"  = muted gray lines for charcoal sections.
 */
const CONTOUR_PATHS = [
  // Cluster A — left-middle ring system (4 irregular nested contours)
  "M330 260 C372 262 396 292 392 322 C388 356 362 380 328 378 C296 376 270 352 268 320 C266 288 292 258 330 260 Z",
  "M332 208 C402 210 452 262 448 322 C444 384 396 432 330 430 C266 428 212 378 210 318 C208 256 262 206 332 208 Z",
  "M330 156 C428 158 508 238 504 324 C500 414 420 484 328 482 C236 480 156 406 154 318 C152 228 236 154 330 156 Z",
  "M332 104 C456 106 562 214 558 326 C554 440 448 536 328 534 C208 532 102 432 100 320 C98 208 210 102 332 104 Z",
  // Cluster B — right-lower ring system (3 contours)
  "M1230 570 C1272 572 1300 604 1298 642 C1296 678 1266 706 1228 704 C1192 702 1162 674 1162 640 C1162 604 1190 568 1230 570 Z",
  "M1232 510 C1306 512 1362 572 1360 642 C1358 712 1300 772 1228 770 C1156 768 1098 710 1098 640 C1098 570 1158 508 1232 510 Z",
  "M1230 440 C1340 444 1424 532 1422 644 C1420 754 1332 842 1226 840 C1120 838 1036 750 1036 640 C1036 530 1122 436 1230 440 Z",
  // Cluster C — top-center ring system (3 contours)
  "M820 120 C850 121 872 144 870 172 C868 198 846 218 818 216 C792 214 770 194 770 168 C770 142 792 119 820 120 Z",
  "M822 75 C878 77 920 120 918 172 C916 224 872 264 818 262 C764 260 722 218 722 168 C722 116 766 73 822 75 Z",
  "M820 20 C906 24 970 92 968 174 C966 254 898 316 816 314 C734 312 668 246 668 166 C668 88 736 16 820 20 Z",
  // Cluster D — top-right small ring system (2 contours)
  "M1490 90 C1516 91 1534 111 1532 136 C1530 160 1510 177 1487 175 C1465 173 1448 155 1448 133 C1448 110 1466 89 1490 90 Z",
  "M1492 40 C1542 42 1580 82 1578 134 C1576 186 1534 224 1486 222 C1438 220 1400 178 1400 130 C1400 80 1442 38 1492 40 Z",
  // Sweeping open contour lines — lower third
  "M-20 780 C220 740 380 830 620 800 C860 770 1000 860 1240 830 C1400 810 1520 850 1620 840",
  "M-20 900 C240 870 420 940 680 915 C940 890 1120 955 1360 930 C1480 918 1560 935 1620 928",
  // Lone short contour — mid right gap filler
  "M1470 420 C1510 424 1536 452 1534 488 C1532 522 1504 546 1468 544 C1434 542 1408 516 1408 484 C1408 450 1434 416 1470 420 Z",
];

const TopoTexture = ({ variant = "light", opacity = 0.04, className = "" }) => {
  const stroke = variant === "dark" ? "#C9C9C3" : "#111111";
  const mask =
    "radial-gradient(ellipse 115% 95% at 50% 45%, transparent 0%, rgba(0,0,0,0.4) 55%, rgba(0,0,0,1) 85%)";
  return (
    <div
      aria-hidden="true"
      data-testid={`topo-texture-${variant}`}
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      style={{ opacity, WebkitMaskImage: mask, maskImage: mask }}
    >
      <svg
        className="w-full h-full"
        viewBox="0 0 1600 1000"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
      >
        <g stroke={stroke} strokeWidth="1.25" strokeLinecap="round">
          {CONTOUR_PATHS.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      </svg>
    </div>
  );
};

export default TopoTexture;
